<template>
  <div class='navbar'>
    <el-menu :default-active="obj.menuIdx" mode="horizontal" style="height:50px;min-width:1600px;"
      background-color="#262f3e" text-color="#c1c6c8" active-text-color="#ffffff" @select="handleSelect">
      <el-image style="width: 30px; height: 30px; padding:0px 30px; padding-top:8px;"
        :src="require('@/assets/logo.png')" :fit="fit" />
      <el-input v-model="obj.searchValue" placeholder="搜索个股 名称/代码" @input="handleInput" @keyup.enter="handleEnter"
        style="width:200px;min-width:200px;padding-top:8px;padding-bottom:8px;padding-right:6px;padding-left:6px">
        <template #prefix>
          <el-icon class="el-input__icon">
            <search />
          </el-icon>
        </template>
      </el-input>
      <!-- <el-menu-item index="0">
        <el-icon>
          <house />
        </el-icon>
        <template #title>首页</template>
      </el-menu-item> -->
      <el-menu-item index="1">
        <el-icon>
          <dataLine />
        </el-icon>
        <template #title>行情</template>
      </el-menu-item>
      <!-- <el-menu-item index="1-2">
        <el-icon>
          <pointer />
        </el-icon>
        <template #title>交易</template>
      </el-menu-item> -->
      <el-menu-item index="2">
        <el-icon>
          <money />
        </el-icon>
        <template #title>信号</template>
      </el-menu-item>
      <el-menu-item index="2-4">
        <el-icon>
          <compass />
        </el-icon>
        <template #title>趋势</template>
      </el-menu-item>
      <el-menu-item index="2-1">
        <el-icon>
          <pieChart />
        </el-icon>
        <template #title>板块</template>
      </el-menu-item>
      <el-menu-item index="3">
        <el-icon>
          <operation />
        </el-icon>
        <template #title>基本</template>
      </el-menu-item>
      <el-menu-item index="4">
        <el-icon>
          <dataAnalysis />
        </el-icon>
        <template #title>收益</template>
      </el-menu-item>
      <el-menu-item index="5">
        <el-icon>
          <document />
        </el-icon>
        <template #title>财务</template>
      </el-menu-item>
      <el-menu-item index="6">
        <el-icon>
          <crop />
        </el-icon>
        <template #title>技术</template>
      </el-menu-item>
      <!-- <el-menu-item index="7">
        <el-icon>
          <connection />
        </el-icon>
        <template #title>相关</template>
      </el-menu-item>
      <el-menu-item index="8">
        <el-icon>
          <cherry />
        </el-icon>
        <template #title>回归</template>
      </el-menu-item> -->
      <el-menu-item index="9">
        <el-icon>
          <cpu />
        </el-icon>
        <template #title>选股</template>
      </el-menu-item>
      <!-- <el-menu-item index="21">
        <el-icon>
          <avatar />
        </el-icon>
        <template #title>我的</template>
      </el-menu-item> -->
      <el-menu-item index="22">
        <el-icon>
          <crop />
        </el-icon>
        <template #title>退出</template>
      </el-menu-item>
    </el-menu>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{ data['name'] }} {{ data['symbol'] }} {{ data['exchange'] }}
        <!-- <span v-if="data['main'] === 1"> *主力 </span> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
export default {
  setup(props, { emit }) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      user: '',
      menuIdx: '',
      searchList: [],
      filteredList: [],
      searchValue: '',
    })

    // 页面传来的menuIdx处理
    vueEvent.on('navbarMenuIdxEvent', (menuIdx) => {
      obj.menuIdx = menuIdx
    })

    // 页面传来的mainClickEvent处理
    vueEvent.on('mainClickEvent', () => {
      obj.filteredList = []
      obj.searchValue = ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderSelect()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('navbarMenuIdxEvent')
      vueEvent.off('mainClickEvent')
    })

    // 菜单点击事件
    const handleSelect = (menuIdx) => {
      emit('topbarEvent', menuIdx) // 抛出事件到父组件
      if (menuIdx === '0') {
        router.push('/')
      } else if (menuIdx === '1') {
        router.push('/market')
      } else if (menuIdx === "1-2") {
        router.push('/trade')
      } else if (menuIdx === "2") {
        router.push('/signal')
      } else if (menuIdx === "2-4") {
        router.push('/trend')
      } else if (menuIdx === "2-1") {
        router.push('/block')
      } else if (menuIdx === "3") {
        router.push('/basic')
      } else if (menuIdx === "4") {
        router.push('/return')
      } else if (menuIdx === "5") {
        router.push('/financial')
      } else if (menuIdx === "6") {
        router.push('/technical')
      } else if (menuIdx === "7") {
        router.push('/correlation')
      } else if (menuIdx === "8") {
        router.push('/regression')
      } else if (menuIdx === "9") {
        router.push('/picking')
      } else if (menuIdx === "21") {
        router.push('/me')
      } else if (menuIdx === "22") {
        handleLogout()
      }
    }

    // 获取合约列表
    const renderSelect = (isLoading = true) => {
      let formData = new FormData()
      formData.append("category", "all")
      formData.append("page", 1)
      formData.append("limit", 10000)
      if (isLoading) {
        http({
          url: `/market`,
          method: 'post',
          data: formData
        }).then((res) => {
          // console.log(res.data.data)
          // processData(res.data.data)
          obj.searchList = res.data.data.data
          setStore()
        }).catch((err) => {
          // clearInterval(obj.timer)
        })
      } else {
        httpNoLoading({
          url: `/market`,
          method: 'post',
          data: formData
        }).then((res) => {
          // console.log(res.data.data)
          // processData(res.data.data)
          obj.searchList = res.data.data.data
          setStore()
        }).catch((err) => {
          // clearInterval(obj.timer)
        })
      }
    }

    // 缓存搜索数据          
    const setStore = () => {
      var storeObj = { 'searchList': obj.searchList }
      store.commit('setSearchData', storeObj)
      // console.log(store.state.searchData.searchList)
    }

    // 获取搜索缓存数据      
    const getStore = () => {
      obj.searchList = store.state.searchData.searchList
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框回车事件
    const handleEnter = () => {
      if (obj.filteredList.length !== 0) {
        obj.searchValue = obj.filteredList[0]['name']
        obj.filteredList = []
        store.commit('setCurrentContract', obj.searchValue)
        router.push(`/candlestick?name=${obj.searchValue}`)
        obj.searchValue = ''
      }
    }

    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.filteredList = []
      store.commit('setCurrentContract', obj.searchValue)
      router.push(`/candlestick?name=${obj.searchValue}`)
      obj.searchValue = ''
    }

    // 按钮退出登录事件
    const handleLogout = () => {
      http({
        url: '/logout',
        method: 'post',
      }).then((res) => {
        router.push('/login')
      })
      // 清空所有缓存
      // store.commit('setWindowWidth', "")
      // store.commit('setWindowHeight', "")
      store.commit('setUser', "")
      store.commit('setCurrentContract', "")
      store.commit('setMyChart', "")
      store.commit('setChatData', "")
      store.commit('setTrendData', "")
      store.commit('setSignalData', "")
      store.commit('setBasicData', "")
      store.commit('setReturnData', "")
      store.commit('setFinancialData', "")
      store.commit('setTechnicalData', "")
      store.commit('setCorrelationData', "")
      store.commit('setRegressionData', "")
      store.commit('setPickingData', "")
      store.commit('setMeData', "")
    }

    return {
      obj,
      handleSelect,
      handleInput,
      handleEnter,
      handleClick,
      handleLogout,
    }
  }
}
</script>
<style lang="scss" scoped>
.navbar {
  width: 100%;
  height: 60px;
  left: 60;
  top: 0;
  position: fixed;
  z-index: 15;
}

.el-menu-item {
  height: 50px !important;
}

.el-menu--horizontal {
  display: flex;
  flex-wrap: nowrap;
  border-bottom: solid 0px var(--el-menu-border-color);
  border-right: none;
}

/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 95px;
  top: 50px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
